module.exports = __webpack_public_path__ + "img/f56.138ad844.png";